import { Link, useSearchParams } from 'react-router-dom';

const VENDOR_EMAIL = 'sales@vantixmt.com';

export function LicenseExpiredPage() {
  const [params] = useSearchParams();
  const reason = params.get('reason') ?? 'expired';
  const isDemo = reason === 'demo';

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
         style={{ background: '#1e3a5f' }}>
      <div className="w-full max-w-lg">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.png?v=4" alt="VantixMT"
               className="w-40 sm:w-56 object-contain drop-shadow-xl" />
        </div>
      <div className="bg-white rounded-2xl shadow-2xl w-full p-8 text-center">

        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          {isDemo ? 'Your free demo has ended' : 'Your license has expired'}
        </h1>

        <p className="text-slate-500 mb-8">
          {isDemo
            ? 'Your 30-day VantixMT demo is complete. Subscribe below to keep your data and continue using the system.'
            : 'Your VantixMT subscription has lapsed. Resubscribe to restore access — your data is intact.'}
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/settings/billing"
            className="flex-1 bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            Subscribe to Cloud
            <span className="block text-sm font-normal opacity-80">From $25 / user / month</span>
          </Link>

          <a
            href={`mailto:${VENDOR_EMAIL}?subject=VantixMT On-Premise License`}
            className="flex-1 bg-brand-600 hover:bg-brand-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            Buy On-Premise
            <span className="block text-sm font-normal opacity-80">Contact sales</span>
          </a>
        </div>

        <p className="text-xs text-slate-400 mt-6">
          Questions? Email{' '}
          <a href={`mailto:${VENDOR_EMAIL}`} className="text-brand-500 hover:underline">
            {VENDOR_EMAIL}
          </a>
        </p>
      </div>
      </div>
    </div>
  );
}
